import * as L from "leaflet"
import { useEotlCore } from '../../store/eotlStore'
import riderIcon from '@eotl/icons/dist/bicycle-1.svg'
import supplierIcon from '@eotl/icons/dist/supplier.svg'
import markerSelected from '../../../assets/icons/marker-icon-selected.png'

export const mapIcons = {
    riders: riderIcon,
    suppliers: supplierIcon,
}

export const getCustomIcon = (L, feature) => {
    return L.icon({
        iconUrl: mapIcons[feature.properties.groupType],
        iconSize: [32, 32],
        iconAnchor: [16, 16],
        popupAnchor: [0, -5]
    })
}

const selectedIcon = L.icon({
    iconUrl: markerSelected,
    className: 'selected-icon'
})

export const findLayerByAddress = (map, address) => {
    let foundLayer = null
    if (map.value.leafletObject) {
        map.value.leafletObject.eachLayer((layer) => {
            if (layer.feature?.properties?.address === address) {
                foundLayer = layer
            }
        })
        return foundLayer
    } else if (map.value.eachLayer) {
        map.value.eachLayer((layer) => {
            if (layer.feature?.properties?.address === address) {
                foundLayer = layer
            }
        })
        return foundLayer
    }

}

export const jumpToLayerAndOpenPopup = (map, address) => {
    const eotlCoreStore = useEotlCore()
    const layer = findLayerByAddress(map, address)

    if (layer) {
        // Using the popup here seems to make more sense behaviour wise, it gives a clear indication and adds the closing 'x' icon and bevaviour that it disapears when clicking out side of it.
        // The tooltip is mostly for hovering effects.
        layer.openPopup()

        const latlng = layer.getLatLng()
        // Pan the map to center on the clicked point
        if (map.value?.leafletObject) {
            map.value.leafletObject.panTo(latlng)
        } else {
            map.value.panTo(latlng)
        }

        // Sets red (selected) point icon if it has no custom icon set
        if (layer.options.icon instanceof L.Icon.Default) {
            layer.setIcon(selectedIcon)
        }

        // Listens to popupclose to deselect the item in the list
        layer.on('popupclose', function (e) {
            eotlCoreStore.activeMapItemByAddress = null
            if (e._icon?.classList.contains('selected-icon')) {
                // Set back default icon when deselect
                layer.setIcon(new L.Icon.Default())
            } else if (e.target._icon.classList.contains('selected-icon')) {
                console.log('e.target._icon //> ', e.target._icon)
                // Set back default icon when deselect
                layer.setIcon(new L.Icon.Default())
            }
        })
    }
}

export const focusOnPoint = (e) => {
    const map = e.target._map
    const latlng = e.latlng

    // Pan the map to center on the clicked point
    map.panTo(latlng)
}